import { render, staticRenderFns } from "./vue-file-preview.vue?vue&type=template&id=1f00ad11&"
import script from "./vue-file-preview.vue?vue&type=script&lang=ts&"
export * from "./vue-file-preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports